import { createSlice } from '@reduxjs/toolkit'
import { RequestorPayloadState } from '../types/requestor.types'

const initialState: RequestorPayloadState = {
  payload: null,
}

const requestorSlice = createSlice({
  name: 'requestor',
  initialState: initialState,
  reducers: {
    updateRequestorConfigReducer: (state: RequestorPayloadState, action) => {
      state.payload = action.payload
    },
  },
})

export const { updateRequestorConfigReducer } = requestorSlice.actions
export default requestorSlice.reducer
